import React, { Component } from "react";
import { connect } from "react-redux";
import { removeUser } from "../../../../actions/admin.actions";
import { getAdminCompanyById } from "../../../../actions/company.actions";
import AdminCompany from "../components/AdminCompany";

class AdminCompanyContainer extends Component {
  constructor(props) {
    super(props);
    this.removeUser = this.removeUser.bind(this);
  }

  componentDidMount() {
    this.props.getAdminCompanyById(this.props.match.params.companyId);
  }

  removeUser(userId) {
    this.props.removeUser(userId, this.props.match.params.companyId);
  }

  render() {
    return (
      <div>
        <AdminCompany
          companyData={this.props.adminCompany}
          removeUser={this.removeUser}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    adminCompany: state.company.adminCompany
  };
};

const mapDispatchToProps = dispatch => ({
  removeUser: (userId, companyId) => dispatch(removeUser(userId, companyId)),
  getAdminCompanyById: companyId => dispatch(getAdminCompanyById(companyId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyContainer.js